import {styled} from '@mui/system';

export const IconContainer = styled('span')(({theme}) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '.5rem',
}));
